import { render } from "./xtx-numbox.vue?vue&type=template&id=2f4bdaaa&scoped=true"
import script from "./xtx-numbox.vue?vue&type=script&lang=js"
export * from "./xtx-numbox.vue?vue&type=script&lang=js"

import "./xtx-numbox.vue?vue&type=style&index=0&id=2f4bdaaa&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4bdaaa"]])

export default __exports__